import { FeatureKey, Rights } from '../../_models/feature';

/** Which zone list a user sees: every zone of the business, or the zones assigned to them. */
export type FoodSafetyZoneListKind = 'all' | 'own';

/** Tabs that are not shown in a zone. */
const HIDDEN_ZONE_TABS = [
  FeatureKey.SJA_CHECKLIST, // not required for navigation
  FeatureKey.TIME_LOG,
  142, // Details, hidden #KW-276
  FeatureKey.CLEANING // checklist
];

/**
 * The tabs of a Food Safety zone. Shared by the zone page and the hover
 * sub-navigation so both list the same tabs.
 * @param children Children of the Food Safety feature node.
 */
export function foodSafetyZoneTabs(children: any[] | null | undefined): any[] {
  return (children ?? [])
    .filter(
      (element: any) =>
        (element.checked || element.IsDefault) &&
        HIDDEN_ZONE_TABS.indexOf(element.id) === -1
    )
    .map((element: any) => {
      if (element.translationKey === 'DEVIATION') {
        return { ...element, translationKey: 'DEVIATIONS' };
      }
      if (element.translationKey === 'DAILY_TASK') {
        return { ...element, translationKey: 'DAILY_TASKS' };
      }
      return element;
    });
}

/**
 * The zone list the Food Safety header (`FoodHeaderListComponent`) opens for a
 * role: guests and users without the administrate right see only their own zones.
 * @param roleId Current role id (`BaseServices.roleId`).
 * @param hasRight Whether the user holds a right.
 */
export function foodSafetyZoneListKind(
  roleId: string,
  hasRight: (rightId: number) => boolean
): FoodSafetyZoneListKind {
  if (+roleId === 4) {
    return 'own';
  }
  if (+roleId === 5) {
    return hasRight(Rights.ADMINISTRATE_FOOD_SAFETY) ? 'all' : 'own';
  }
  return 'all';
}
